// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (max-width:1439px){.menu-item-televizory{display:none}}@media only screen and (max-width:1200px){.menu-item-dyson{display:none}}", ""]);
// Exports
module.exports = exports;
